import { IWorkerAssignmentEvaluation } from '@/services';
import { WorkerAssignmentActions, WorkerAssignmentSelectors } from '@/stores';
import { insertObjectIf } from '@/utils';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { APPRAISAL_INFO_LIST } from './appraisal-info-popup.config';
import { TAppraisalInfoPopupProps } from './appraisal-info-popup.type';

export const useLogic = ({ id, open }: TAppraisalInfoPopupProps) => {
	const dispatch = useDispatch();

	const evaluation = useSelector(WorkerAssignmentSelectors.selectEvaluation);

	const appraisalInfoList = useMemo(() => {
		return APPRAISAL_INFO_LIST.map((item) => {
			return {
				...item,
				...insertObjectIf(
					evaluation[item.key as keyof IWorkerAssignmentEvaluation],
					{
						value: evaluation[item.key as keyof IWorkerAssignmentEvaluation],
					}
				),
			};
		});
	}, [evaluation]);

	useEffect(() => {
		if (!open) return;
		dispatch(
			WorkerAssignmentActions.getWorkerAssignmentEvaluationRequest({ id })
		);
	}, [id, open]);

	return { appraisalInfoList };
};
